import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import LabelInput from 'components/sales/Input/labelInput/labelInput';
import ButtonWithIcon from 'components/sales/buttons/buttonWithIcon/buttonWithIcon';
import Regex from 'services/utils/regex/Regex';
import Loader from 'components/sales/Loader/loader';
import './login.css';
const Login = ({ generateOtp, otp, history }) => {
  const [userId, setUserId] = useState('');
  const [isError, setIserror] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const userIdRef = useRef(null);

  useEffect(() => {
    userIdRef.current.focus();
  }, [userIdRef]);

  useEffect(() => {
    var isWebview = true;
    // CHECKOUT
    // console.log(attCheckInSite); return false;
    // if(localStorage.getItem('isWebview')){
    //   isWebview = localStorage.getItem('isWebview');
    // }
    // console.log(isWebview); 
    if(isWebview){
      const RNWebView =  window["ReactNativeWebView"];
      console.log(RNWebView);
      console.log("RNWebView");
      if (RNWebView) {
          const contentStr = {
              event: "LOGOUT",
              data: null,
              os: "ANDROID",
          };
      
          RNWebView.postMessage(JSON.stringify(contentStr));
          localStorage.clear();
          sessionStorage.clear();
          setTimeout(() => {
          localStorage.clear();
          sessionStorage.clear();
          window.location.reload();
          }, 100);
      }
    }
  }, []);

  const handleSubmit = async (evt) => {
    evt.preventDefault();
    if (Regex.email.test(userId)) {
      setIserror('');
      setIsLoading(true);
      const res = await generateOtp(userId);
      setIsLoading(false);
      if (res === true) {
        var fusionState = localStorage.getItem("fusion-state") ? localStorage.getItem("fusion-state") : null;
        if(fusionState){
          history.push({
            pathname: '/login-otp',
            state: { otp: otp, email: userId },
          });
        }else{
          history.push({
            // pathname: '/login-otp',
            pathname: '/sso-login',
            state: { otp: otp, email: userId },
          });
        }
      
      }
    } else {
      if (userId === '') {
        setIserror(localization.mandatoryField);
      } else setIserror(localization.loginErrorMg);
    }
  };

  return (
    <div className="login-box">
      <div className="login-logo">
        <img src={Images?.Logo} alt="" style={{"width" : "18%"}}/>
        <span>{localization.fusion}</span>
      </div>
      <div className="login-container">
        <Loader isLoading={isLoading} />
        <div className="login-fieldset">
          <h4>{localization.loginToAccount}</h4>
          <form onSubmit={handleSubmit}>
            <LabelInput
              ref={userIdRef}
              className={`${userId.length ? '' : 'empty'}`}
              inputValue={userId}
              handleChange={(e) => setUserId(e.target.value.trim())}
              type="text"
              label={localization.emailIdNo}
              errorMsg={isError}
            />
            <div className="form-group form-stat">
              <b className="New-form">
              <ButtonWithIcon 
                title={localization.reqOtp}
                type="submit" 
                src={Images?.ArrowRight}
              />
              </b>
            </div>
          </form>
        </div>
      </div>
      <div className="copyright">
        <strong>{localization.copyRight}</strong>
      </div>
    </div>
  );
};

Login.propTypes = {
  generateOtp: PropTypes.func.isRequired,
  otp: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.bool,
  ]),
  history: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default Login;
